import {html} from "@isceco/widget-library2/external/lit";

import '@isceco/widget-library2/basic-elements/Button/Button'
import '@isceco/widget-library2/basic-elements/Popup/Popup'

export default class EditableCell {

  get name() {
    return 'Editable' + this.cell.name
  }

  constructor({cell, editCallback, helpIcon = 'info circle', helpText}) {
    this.cell = cell
    this.editCallback = editCallback
    this.helpIcon = helpIcon
    this.helpText = helpText
  }

  render(i18n, cell, row) {
    return html`
      <div style="display: flex; flex-direction: row; align-items: center">
        ${this.cell.render(i18n, cell, row)}
        ${this.renderHelp(i18n, cell, row)}
        ${this.renderButton(row)}
      </div>
    `
  }

  renderHelp(i18n, cell, row) {
    const text = this.helpText instanceof Function ? this.helpText({i18n, cell, row}) : this.helpText
    if (text) {
      return html`
        <isceco-popup style="margin-left: var(--isceco-space-100)">
          <i slot="wrapper" class="icon ${this.helpIcon}"></i>
          <div slot="content" style="white-space: pre-line">${text}</div>
        </isceco-popup>
      `
    }
    return html``
  }

  renderButton(row) {
    if (this.editCallback) {
      return html`
        <isceco-button icon="edit"
                       variant="tertiary"
                       size="small"
                       style="margin-left: auto"
                       @click="${() => this.editCallback(row)}"
        ></isceco-button>
      `
    }
    return html``
  }
}
